import { nanoId } from '@/helpers'
import Vue from 'vue'

export const SET_BASE = (state, value) => {
  state.base = !value ? 0 : value
}

export const SET_TYPE = (state, { key, value }) => {
  state._[key].type = value
}

export const SET_PERCENT = (state, { key, value }) => {
  state._[key].percent = value
}

export const SET_IVA_TYPE = (state, { key, value }) => {
  state._[key].specialCode = value
}

export const SET_REASON = (state, { key, value }) => {
  state._[key].specialReason = value
}

/* TODO remove temporary solution until API gives separated values */
export const SET_TAX = (state, { key, payload }) => {
  Vue.set(state._, key, payload)
}

export const ADD = (state, payload) => {
  let key = nanoId(8)
  state.list.push(key)
  Vue.set(state._, key, Object.assign({}, payload))
}

export const DELETE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
